import MentoringMember from './MentoringMember.vue';

export default MentoringMember;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/member/index.ts